export default __webpack_public_path__ + "static/media/Quick_Actions_Line.4e5c7c2c.svg";